import React from 'react'
import {useTranslation} from 'react-i18next'

export function DriverOnBoardingScreen() {
    const {t} = useTranslation()
    return <div>{t('home.driverOnBoarding.message')}</div>
}
